import { useEffect, useState } from 'react';
import { IOption } from 'shared/components/Dropdown';
import { PersistedStateKeys } from 'shared/enums';
import usePersistedState from 'shared/hooks/usePersistedState';

interface IUseManageTerminalsOutput {
  terminalOption: IOption | undefined;
  setTerminalOption: (terminalOption: IOption | undefined) => void;
  lastSelectedTerminalId: string;
  setLastSelectedTerminalId: (lastSelectedTerminalId: string) => void;
}

export const useManageTerminals = (terminalOptions: IOption[] | undefined): IUseManageTerminalsOutput => {
  // The selected terminal for a terminal transaction.
  const [terminalOption, setTerminalOption] = useState<IOption | undefined>(
    terminalOptions?.filter(({ value }) => value?.status === 'online')?.length ? terminalOptions?.[0] : undefined,
  );

  const [lastSelectedTerminalId, setLastSelectedTerminalId] = usePersistedState<string>(
    PersistedStateKeys.LastSelectedTerminalId,
    '',
  );

  // Check for the last terminal clicked and if it's online,
  // if not and there is only one terminal location, and it is online select it.
  useEffect(() => {
    if (lastSelectedTerminalId) {
      const lastSelectedTerminal = terminalOptions?.find(
        (terminalOption) => terminalOption?.value.id === lastSelectedTerminalId,
      );
      if (lastSelectedTerminal?.value?.status === 'online') setTerminalOption(lastSelectedTerminal);
    } else if (terminalOptions?.length) {
      const firstTerminal = terminalOptions?.find((terminalOption) => terminalOption?.value?.status === 'online');
      if (firstTerminal) {
        setTerminalOption(firstTerminal);
      }
    }
  }, [lastSelectedTerminalId, terminalOptions]);

  return { terminalOption, setTerminalOption, lastSelectedTerminalId, setLastSelectedTerminalId };
};
